import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { loginLogo } from "@/lib/brand";
import PasswordForm from "@/components/auth/PasswordForm";

const LOGO = loginLogo();

/**
 * Shown instead of every page while the session must choose a password: the first sign-in with an old PIN, or with a
 * temporary password from an administrator. The server refuses everything else until this is done.
 */
export default function ChoosePassword() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center p-4 sm:p-6 bg-[var(--bg)]" data-testid="choose-password">
      <div className="w-full max-w-md bg-[var(--surface)] border border-[var(--border)] rounded-2xl p-6 sm:p-8 shadow-sm">
        {LOGO && <img src={LOGO} alt="MADIO" className="h-7 w-auto mb-6" />}
        <div className="flex items-center gap-2 text-[var(--brand)] mb-2"><ShieldCheck size={20} />
          <span className="text-xs uppercase tracking-[0.16em] font-semibold">One-time step</span>
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-[var(--ink)] mb-1">Choose your password</h1>
        <p className="text-sm text-[var(--ink-2)] mb-6">
          {user?.name ? `${user.name}, the` : "The"} CRM now uses passwords instead of 4-digit PINs. Choose one only you know;
          you will use it with your username{user?.email ? " or email" : ""} from now on.
        </p>
        <PasswordForm submitLabel="Save and continue" />
        <button type="button" onClick={logout} className="mt-4 w-full text-xs text-[var(--ink-3)] hover:text-[var(--ink)]" data-testid="pw-signout">
          Not you? Sign out
        </button>
      </div>
    </div>
  );
}
